module.exports = {
  customRoutes: [],
  customDispatchedRoutes: [],
};
